import React from 'react';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import { IntlProvider } from 'react-intl';
import { loadLanguagePack } from '@americanexpress/one-app-ducks';
import PropTypes from 'prop-types';
import { ProgressCircular } from '@americanexpress/dls-react';
import { composeModules } from 'holocron';
import childRoutes from '../childRoutes';
import { ROUTE } from '../utils/constants';

const VirtualCardsRecipientWrapper = ({
  languageData, locale, children,
  GlobalHeader, GlobalFooter, location,
}) => {
  if (Object.entries(languageData).length === 0) {
    return <ProgressCircular />;
  }

  // Determine if user is authenticated based on current route
  // Routes that require authentication
  const authenticatedRoutes = [ROUTE.DASHBOARD, ROUTE.PROFILE];
  const isAuthenticated = authenticatedRoutes.some(
    (route) => location?.pathname?.includes(route)
  );

  return (
    <div>
      <GlobalHeader isAuthenticated={isAuthenticated} />
      <div>
        <IntlProvider locale={locale} messages={languageData}>
          {children}
        </IntlProvider>
      </div>
      <GlobalFooter />
    </div>
  );
};

VirtualCardsRecipientWrapper.childRoutes = childRoutes;

export const TestableAxpVirtualCardsRecipient = VirtualCardsRecipientWrapper;

VirtualCardsRecipientWrapper.propTypes = {
  languageData: PropTypes.shape({}).isRequired, // no need to restate all the keys in the lang pack
  locale: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  GlobalHeader: PropTypes.elementType.isRequired,
  GlobalFooter: PropTypes.elementType.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
};

export const loadModuleData = async ({ store }) => {
  const { dispatch } = store;
  await dispatch(loadLanguagePack('virtual-cards-recipient-journey-wrapper', { fallbackLocale: 'en-us' }));
  await dispatch(composeModules([{ name: 'manage-virtual-cards-servicing' }]));
};

VirtualCardsRecipientWrapper.holocron = {
  name: 'virtual-cards-recipient-journey-wrapper',
  loadModuleData,
};

export default oneAppModuleWrapper('virtual-cards-recipient-journey-wrapper')(VirtualCardsRecipientWrapper);
